import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { bucket_url } from '../../constants/const'
import Gallery, { Photo } from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";

// import { photos } from "../../data/photos";


const PhotoGallery = ({ photos }) => {

    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = useCallback((event, { photo, index }) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    }, []);

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    return (
        photos ? <div className="w-100">
            {photos.length > 9 ? <Gallery
                photos={photos}
                onClick={openLightbox}
                direction="row"
                targetRowHeight={150}
            /> :
                <Gallery
                    photos={photos}
                    onClick={openLightbox}
                />}
            <ModalGateway>
                {viewerIsOpen ? (
                    <Modal onClose={closeLightbox}>
                        <Carousel
                            currentIndex={currentImage}
                            views={photos.map(x => ({
                                ...x,
                                srcset: x.srcSet,
                                caption: x.title
                            }))}
                        />
                    </Modal>
                ) : null}
            </ModalGateway>
        </div> : null
    )
}

export default PhotoGallery;